var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWashAndSterilization2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 127.17 95.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#dcb998;}.cls-2{fill:#c5a07d;}.cls-3{fill:#ececec;}.cls-4{fill:#c8cad1;}.cls-5{fill:#ded6ce;}.cls-17,.cls-22,.cls-26,.cls-6,.cls-7,.cls-8{fill:none;}.cls-6{stroke:#a3866a;}.cls-17,.cls-22,.cls-24,.cls-26,.cls-6,.cls-7,.cls-8{stroke-miterlimit:10;}.cls-7{stroke:#f2dac5;}.cls-8{stroke:#fdebdd;}.cls-9{fill:#f2dac5;}.cls-10{fill:#828282;}.cls-11{fill:#cbd5e4;}.cls-12{fill:#b8c6cf;}.cls-13{fill:#b9bdc1;}.cls-14{fill:#8ab3ff;}.cls-15{fill:#343f42;}.cls-16{fill:#588df0;}.cls-17{stroke:#588df0;}.cls-17,.cls-22{stroke-width:0.97px;}.cls-18{fill:#303b3e;}.cls-19{fill:#f44d4d;}.cls-20{fill:#f66562;}.cls-21{fill:#d0d6e2;}.cls-22{stroke:#303b3e;}.cls-23{fill:#9caab2;}.cls-24,.cls-25{fill:#d0d6e1;}.cls-24,.cls-26{stroke:#343f42;}"), /*#__PURE__*/React.createElement("symbol", {
    id: "BoxOpen_01a",
    "data-name": "BoxOpen_01a",
    viewBox: "0 0 119.7 94.43"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "13.3 16.85 53.2 39.88 59.85 37.72 59.85 1.72 13.3 16.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "99.75 24.76 59.85 37.72 59.85 1.72 99.75 24.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M92.21,32.7a1.6,1.6,0,0,0-.91-1.2l0-1.94h0c0-.52-.58-1-1.62-1.36a7.66,7.66,0,0,0-4.4,0,2.44,2.44,0,0,0-.65-.55l0-1.94h0c0-.52-.58-1-1.62-1.36a7.66,7.66,0,0,0-4.4,0,2.44,2.44,0,0,0-.65-.55l0-1.94h0c0-.51-.58-1-1.62-1.36a7.66,7.66,0,0,0-4.4,0,2.44,2.44,0,0,0-.65-.55l0-1.94h0c0-.51-.58-1-1.62-1.36a7.66,7.66,0,0,0-4.4,0,2.44,2.44,0,0,0-.65-.55l0-1.94h0c0-.51-.58-1-1.62-1.36a7,7,0,0,0-5.14.35,1.11,1.11,0,0,0-.64.93h0l0,1.88-.14.08a1.38,1.38,0,0,0-.8,1.16h0l0,1.67-.13-.07V16.9h0c0-.52-.59-1-1.63-1.34a7,7,0,0,0-5.14.4c-.44.29-.65.61-.63.94h0v1.88l-.14.07A1.41,1.41,0,0,0,47.88,20h0v1.6l-.09-.05V19.64h0c0-.52-.6-1-1.64-1.34a7,7,0,0,0-5.14.4,1.12,1.12,0,0,0-.63.94h0v1.88a.91.91,0,0,0-.14.07,1.4,1.4,0,0,0-.78,1.18h0v1.59l-.09-.05V22.37h0c0-.51-.59-1-1.63-1.34a7,7,0,0,0-5.14.4,1.12,1.12,0,0,0-.63.94h0v1.89l-.14.07A1.43,1.43,0,0,0,31,25.5h0v1.6l-.09-.05V25.11h0c0-.51-.6-1-1.64-1.34a7,7,0,0,0-5.14.4,1.11,1.11,0,0,0-.62.94h0V27l-.13.08a1.36,1.36,0,0,0-.79,1.17h0v1.6l-.09-.05V27.85h0c0-.52-.6-1-1.64-1.34a7,7,0,0,0-5.14.4,1.12,1.12,0,0,0-.63.94h0v1.88a.91.91,0,0,1-.14.07A1.4,1.4,0,0,0,14.19,31h0V43.12h0c0,.65.74,1.28,2,1.68a9.81,9.81,0,0,0,4.6.17v2h0c0,.64.74,1.28,2,1.68a9.81,9.81,0,0,0,4.6.17v2h0c0,.64.74,1.28,2,1.68a9.81,9.81,0,0,0,4.6.17v2h0c0,.64.74,1.28,2,1.68a10,10,0,0,0,4.6.17v2h0c0,.64.74,1.28,2,1.67,2.12.65,5,.43,6.43-.5A1.38,1.38,0,0,0,50,58.48h0v-1.6a4.79,4.79,0,0,0,1.22.54,8.81,8.81,0,0,0,6.42-.5,1.4,1.4,0,0,0,.78-1.18h0v-1.6a4.71,4.71,0,0,0,1.21.54,8.8,8.8,0,0,0,6.42-.5A1.39,1.39,0,0,0,66.89,53h0V51.41a5.28,5.28,0,0,0,1.21.53c2.13.65,5,.43,6.43-.5a1.39,1.39,0,0,0,.78-1.17h0v-1.6a4.91,4.91,0,0,0,1.21.54c2.12.64,5,.42,6.42-.51a1.38,1.38,0,0,0,.79-1.17h0V45.94a4.79,4.79,0,0,0,1.11.5c2.12.67,5,.48,6.43-.43a1.38,1.38,0,0,0,.8-1.17h0l.13-12.14Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 61.02,
    cy: 14.35,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(45.35 75.04) rotate(-88.76)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 52.51,
    cy: 17.09,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(34.86 69.41) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 44.09,
    cy: 19.82,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(23.79 63.69) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 35.66,
    cy: 22.56,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(12.72 57.98) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 27.24,
    cy: 25.3,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(1.65 52.26) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 18.81,
    cy: 28.03,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(-9.42 46.54) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 67.67,
    cy: 18.19,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(48.02 85.45) rotate(-88.76)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 59.16,
    cy: 20.93,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(37.6 79.86) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 50.74,
    cy: 23.66,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(26.53 74.14) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 42.31,
    cy: 26.4,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(15.46 68.42) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 33.89,
    cy: 29.14,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(4.39 62.71) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 25.46,
    cy: 31.87,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(-6.68 56.99) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 74.32,
    cy: 22.03,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(50.69 95.85) rotate(-88.76)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 65.81,
    cy: 24.76,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(40.34 90.3) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 57.39,
    cy: 27.5,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(29.27 84.59) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 48.96,
    cy: 30.24,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(18.19 78.87) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 40.54,
    cy: 32.98,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(7.12 73.15) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 32.11,
    cy: 35.71,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(-3.95 67.44) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 80.97,
    cy: 25.87,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(53.35 106.26) rotate(-88.76)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 72.46,
    cy: 28.6,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(43.07 100.75) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 64.04,
    cy: 31.34,
    rx: 1.31,
    ry: 2.96,
    transform: "matrix(0.01, -1, 1, 0.01, 32, 95.03)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 55.61,
    cy: 34.08,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(20.93 89.32) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 47.19,
    cy: 36.82,
    rx: 1.31,
    ry: 2.96,
    transform: "matrix(0.01, -1, 1, 0.01, 9.86, 83.6)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 38.76,
    cy: 39.55,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(-1.21 77.89) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 87.62,
    cy: 29.71,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(56.02 116.66) rotate(-88.76)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 79.11,
    cy: 32.44,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(45.81 111.2) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 70.69,
    cy: 35.18,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(34.74 105.48) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 62.26,
    cy: 37.92,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(23.67 99.77) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 53.84,
    cy: 40.65,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(12.6 94.05) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 45.41,
    cy: 43.39,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(1.53 88.33) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "99.75 24.76 53.2 39.88 53.2 93.88 99.75 78.76 99.75 24.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.3 16.85 53.2 39.88 53.2 93.88 13.3 70.85 13.3 16.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "33.25 34.36 46.55 42.04 46.55 54.04 33.25 46.36 33.25 34.36"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 53.2,
    y1: 39.88,
    x2: 53.2,
    y2: 93.88
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-6",
    points: "99.75 78.76 53.2 93.88 13.3 70.85"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 99.75,
    y1: 24.76,
    x2: 99.75,
    y2: 78.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 59.85,
    y1: 1.72,
    x2: 99.75,
    y2: 24.76
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "53.2 39.88 99.75 24.76 113.05 44.44 66.5 59.56 53.2 39.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "13.3 16.85 53.2 39.88 39.9 56.2 0 33.17 13.3 16.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "79.8 7.24 59.85 1.72 99.75 24.76 119.7 30.27 79.8 7.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "46.48 0 59.85 1.72 13.3 16.85 0 15.17 46.48 0"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "Console_01a",
    "data-name": "Console_01a",
    viewBox: "0 0 69.82 154.44"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "69.82 26.88 69.82 146.88 46.55 154.44 46.55 76.44 60.31 29.82 69.82 26.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "13.3 3.24 23.27 0 69.82 26.88 60.31 29.82 13.3 3.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "0 49.56 46.55 76.44 60.31 29.82 13.3 3.24 0 49.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "0 127.56 46.55 154.44 46.55 76.44 0 49.56 0 127.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "51.78 40.35 22.51 23.42 14.63 50.97 43.9 67.9 51.78 40.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M23.7,26.35,49.5,41.28,42.71,65,16.91,50.05l6.79-23.7m-1.19-2.93L14.63,51,43.9,67.9l7.88-27.54L22.51,23.42Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "32.65 35.68 23.86 30.63 19.13 47.16 27.92 52.21 32.65 35.68"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 47.29,
    y1: 44.13,
    x2: 35.57,
    y2: 37.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 45.7,
    y1: 49.68,
    x2: 33.99,
    y2: 42.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 44.12,
    y1: 55.19,
    x2: 32.42,
    y2: 48.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 42.55,
    y1: 60.7,
    x2: 30.84,
    y2: 53.93
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M50.08,36.19a2.87,2.87,0,0,0,3.39-2,4,4,0,0,0-1.88-4.4,3.27,3.27,0,0,0-1-.38,2.85,2.85,0,0,0-3.39,2,4,4,0,0,0,1.88,4.4A3.49,3.49,0,0,0,50.08,36.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M45.76,31.59l3.58-1a1.83,1.83,0,0,1,1.59.18,3,3,0,0,1,1.38,3.18,1.6,1.6,0,0,1-.84,1l-4,1.18A1.9,1.9,0,0,1,46,35.91a3,3,0,0,1-1.38-3.18A1.59,1.59,0,0,1,45.76,31.59Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-20",
    cx: 46.63,
    cy: 33.86,
    rx: 1.91,
    ry: 2.46,
    transform: "translate(-10.58 26.93) rotate(-29.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M41.29,31.14a2.87,2.87,0,0,0,3.39-2,4,4,0,0,0-1.88-4.4,3.27,3.27,0,0,0-1-.38,2.86,2.86,0,0,0-3.39,2,4,4,0,0,0,1.88,4.4A3.82,3.82,0,0,0,41.29,31.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M37,26.54l3.58-1a1.83,1.83,0,0,1,1.59.18,2.94,2.94,0,0,1,1.38,3.18,1.6,1.6,0,0,1-.84,1l-4,1.18a1.9,1.9,0,0,1-1.42-.23,3,3,0,0,1-1.38-3.18A1.59,1.59,0,0,1,37,26.54Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-20",
    cx: 37.84,
    cy: 28.81,
    rx: 1.91,
    ry: 2.46,
    transform: "translate(-9.23 22.02) rotate(-29.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M34.26,26.78a2.52,2.52,0,0,0,3-1.81,3.73,3.73,0,0,0-1.75-4.09,2.85,2.85,0,0,0-.9-.35,2.52,2.52,0,0,0-3,1.8,3.77,3.77,0,0,0,1.76,4.1A3.5,3.5,0,0,0,34.26,26.78Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-21",
    cx: 34.45,
    cy: 23.65,
    rx: 1.91,
    ry: 2.46,
    transform: "translate(-7.15 19.72) rotate(-29.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M28.4,23.41a2.52,2.52,0,0,0,3-1.81,3.74,3.74,0,0,0-1.75-4.09,3.17,3.17,0,0,0-.89-.35,2.54,2.54,0,0,0-3,1.81,3.76,3.76,0,0,0,1.76,4.09A3.17,3.17,0,0,0,28.4,23.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-21",
    cx: 28.59,
    cy: 20.28,
    rx: 1.91,
    ry: 2.46,
    transform: "translate(-6.25 16.45) rotate(-29.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M22.54,20a2.51,2.51,0,0,0,3-1.81,3.74,3.74,0,0,0-1.75-4.09,3.5,3.5,0,0,0-.89-.35,2.52,2.52,0,0,0-3,1.81,3.73,3.73,0,0,0,1.75,4.09A2.89,2.89,0,0,0,22.54,20Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-21",
    cx: 22.73,
    cy: 16.92,
    rx: 1.91,
    ry: 2.46,
    transform: "translate(-5.36 13.18) rotate(-29.08)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "21.35 22.74 13.47 50.29 4.68 45.24 12.56 17.69 21.35 22.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M15.09,28.64a2.52,2.52,0,0,0,3-1.81,3.74,3.74,0,0,0-1.75-4.09,3.5,3.5,0,0,0-.89-.35,2.52,2.52,0,0,0-3,1.81,3.73,3.73,0,0,0,1.75,4.09A2.89,2.89,0,0,0,15.09,28.64Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-21",
    cx: 15.28,
    cy: 25.52,
    rx: 1.91,
    ry: 2.46,
    transform: "translate(-10.48 10.64) rotate(-29.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M12.73,36.91a2.53,2.53,0,0,0,3-1.81A3.75,3.75,0,0,0,14,31a2.71,2.71,0,0,0-.89-.35,2.51,2.51,0,0,0-3,1.81,3.74,3.74,0,0,0,1.75,4.09A3.43,3.43,0,0,0,12.73,36.91Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-21",
    cx: 12.91,
    cy: 33.78,
    rx: 1.91,
    ry: 2.46,
    transform: "translate(-14.79 10.54) rotate(-29.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M10.36,45.17a2.52,2.52,0,0,0,3-1.81,3.74,3.74,0,0,0-1.75-4.09,3.17,3.17,0,0,0-.89-.35,2.54,2.54,0,0,0-3,1.81,3.76,3.76,0,0,0,1.76,4.09A3.17,3.17,0,0,0,10.36,45.17Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-21",
    cx: 10.55,
    cy: 42.05,
    rx: 1.91,
    ry: 2.46,
    transform: "translate(-19.11 10.43) rotate(-29.08)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-22",
    x1: 17.14,
    y1: 31.61,
    x2: 11.28,
    y2: 28.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-22",
    x1: 14.82,
    y1: 39.72,
    x2: 8.96,
    y2: 36.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-22",
    x1: 12.42,
    y1: 48.1,
    x2: 6.56,
    y2: 44.73
  }), /*#__PURE__*/React.createElement("g", {
    id: "New_Symbol_2",
    "data-name": "New Symbol 2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "5.78 69.96 32.38 85.32 32.38 121.32 5.78 105.96 5.78 69.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "29.06 86.4 28.99 101.35 22.41 97.56 22.41 82.56 29.06 86.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "19.08 92.64 19.01 110.59 9.11 104.88 9.11 86.88 19.08 92.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "29.06 104.4 28.99 116.4 22.41 112.6 22.41 100.56 29.06 104.4"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-26",
    x1: 9.11,
    y1: 77.88,
    x2: 19.08,
    y2: 83.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-26",
    x1: 9.11,
    y1: 80.88,
    x2: 19.08,
    y2: 86.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-26",
    x1: 9.11,
    y1: 83.88,
    x2: 19.08,
    y2: 89.64
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Overblik"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vask_Sterilisation_01",
    "data-name": "Vask & Sterilisation 01"
  }, /*#__PURE__*/React.createElement("use", {
    width: 119.7,
    height: 94.43,
    transform: "translate(0 19.82) scale(0.62)",
    xlinkHref: "#BoxOpen_01a"
  }), /*#__PURE__*/React.createElement("use", {
    width: 69.82,
    height: 154.44,
    transform: "translate(83.88) scale(0.62)",
    xlinkHref: "#Console_01a"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWashAndSterilization2);
export default __webpack_public_path__ + "static/media/wash-and-sterilization-2.223949b8d42911dba81d7380379210ed.svg";
export { ForwardRef as ReactComponent };